import React from "react";
import {
    Box,
    Container,
    Heading,
    Text,
    VStack,
} from "@chakra-ui/react";
import PublicNavbar from "../Landing/PublicNavbar";
import PublicFooter from "../Landing/PublicFooter";
import { WashiTape, DoodlePaperclip } from "../../CustomUi/DoodleIcons";
import { usePageTitle } from "../../../hooks/usePageTitle";

const TermsPage: React.FC = () => {
    usePageTitle(
        "Terms of Service",
        "Terms and conditions governing the use of the Result by Numero school management platform."
    );
    return (
        <Box minH="100vh" bg="#FAF8F2">
            <PublicNavbar />

            <Box py={[12, 16]} className="notebook-dots">
                <Container maxW="4xl">
                    <Box
                        position="relative"
                        p={[6, 12]}
                        bg="white"
                        borderRadius="2xl"
                        border="3px solid #0A3D2E"
                        boxShadow="6px 8px 0px #0A3D2E"
                    >
                        <WashiTape angle={-3} top="-14px" left="36px" tapeColor="#FEF08A" label="Terms 📜" />
                        <DoodlePaperclip color="#10B981" size={36} position="absolute" top="-16px" right="36px" />

                        <VStack align="start" gap={8} pt={2}>
                            <VStack align="start" gap={1}>
                                <Heading as="h1" fontSize={["2xl", "3xl", "4xl"]} fontWeight="extrabold" color="gray.900">
                                    Terms of Service
                                </Heading>
                                <Text color="gray.500" fontSize="xs" fontWeight="bold">
                                    Last updated: November 2025 · Numero Technology Limited
                                </Text>
                            </VStack>

                            <VStack align="start" gap={6} color="gray.700" lineHeight="1.8" fontSize="sm">
                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        1. Acceptance of Terms
                                    </Heading>
                                    <Text>
                                        By accessing and using Result (&ldquo;the Service&rdquo;), provided by Numero Technology Limited, you accept and agree to be bound by these terms. When using these services you shall also be subject to any posted guidelines or rules applicable to such services.
                                    </Text>
                                </Box>

                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        2. Description of Service
                                    </Heading>
                                    <Text>
                                        Result provides a school management and financial operating system for educational institutions. The Service includes academic record keeping, continuous assessment processing, virtual account infrastructure, and reporting tools.
                                    </Text>
                                </Box>

                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        3. User Accounts &amp; Security
                                    </Heading>
                                    <Text>
                                        To access certain features of the Service, you must register for an account. You agree to provide accurate, current, and complete information during registration and to keep such credentials confidential.
                                    </Text>
                                </Box>

                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        4. Fees and Payments
                                    </Heading>
                                    <Text>
                                        Access to the Service is subject to the fees described in our Pricing section.
                                        A flat processor fee of ₦100 applies to financial transactions processed through dedicated virtual accounts. Subscription fees are billed monthly or termly as per your selected plan.
                                    </Text>
                                </Box>

                                <Box>
                                    <Heading as="h3" fontSize="md" fontWeight="bold" mb={2} color="gray.900">
                                        5. Data Privacy and Ownership
                                    </Heading>
                                    <Text>
                                        Your school owns all student, academic, and financial data entered into Result. We implement industry-standard encryption, continuous backup safeguards, and role-based access to ensure confidentiality and integrity.
                                    </Text>
                                </Box>
                            </VStack>
                        </VStack>
                    </Box>
                </Container>
            </Box>

            <PublicFooter />
        </Box>
    );
};

export default TermsPage;
